export const AllLang = JSON.parse(process.env.REACT_APP_SUPPORTED_LANG);
